import React from 'react';
import { GiPowerButton } from "react-icons/gi";
import Dropdown from '../components/DropDown';

const ManualController = ({ filter, index, handleUpdate }) => {
    // Access the specific filter from Redux using the filterIndex

    return (
        <div className="manual-controller">
            <div className="type-bypass control-box">
                <div className='type'>
                    <Dropdown
                        value={filter.type}
                        index={index}
                        onChange={(newType) => handleUpdate(index, 'type', newType)}
                    />
                </div>

                <div className='bypass'>
                    <button className={`bypass-button button ${filter.bypass ? 'bypass' : ''}`}
                        onClick={() => handleUpdate(index, 'bypass', !filter.bypass)}>
                        <span><GiPowerButton /></span>
                    </button>
                </div>

            </div>


            <div className="freq control-box">
                <label>Freq</label>
                <input className='slider'
                    type="range"
                    min="0"  // Change min to 0
                    max="100"
                    step="0.1"
                    value={(Math.log10(filter.frequency) - Math.log10(20)) * (100 / (Math.log10(20000) - Math.log10(20)))} // Normalize range
                    onChange={(e) => {
                        const logValue = Math.log10(20) + (parseFloat(e.target.value) / 100) * (Math.log10(20000) - Math.log10(20));
                        const frequency = Math.pow(10, logValue);
                        handleUpdate(index, 'frequency', frequency);
                    }}
                />

                <span>{filter.frequency.toFixed(2)} Hz</span>
            </div>


            {/* Q Editor */}
            <div className="Q control-box">
                <label>Q</label>
                <input className='slider'
                    type="range"
                    min="0.1"
                    max="12"
                    step="0.1"
                    value={filter.Q}
                    onChange={(e) =>
                        handleUpdate(index, 'Q', Math.max(0.1, Math.min(12, parseFloat(e.target.value) || 0)))
                    }
                />
                <span>{filter.Q.toFixed(2)}</span>
            </div>


            {/* Gain Editor */}
            <div className="gain control-box">
                <label> Gain</label>
                <input className='slider'
                    type="range"
                    min="-12"
                    max="12"
                    step="0.1"
                    value={filter.gain}
                    onChange={(e) =>
                        handleUpdate(index, 'gain', Math.max(-40, Math.min(40, parseFloat(e.target.value) || 0)))
                    }
                />
                <span>{filter.gain.toFixed(2)} db</span>
            </div>
        </div>
    );
};

export default ManualController;
